import React from 'react';
import { FieldType } from 'types/FieldTypes';
import FormModal from 'components/modals/FormModal';

// Rename the name of the function:
const PersonForm: React.FC<{ 
    viewKey?: string, 
    linkedItem?: { [key: string]: number },
    searchValue?: string  
}> = ({ 
    viewKey, linkedItem, searchValue 
}) => {

    const apiObject = 'person';

    // Parse the person name
    const parsePersonName = (searchValue: string): { title?: string, first_name?: string, last_name?: string } => {

        // Trim and clean the search value and first word
        const cleaned = searchValue.trim().replace(/\s+/g, ' ');
        const parts = cleaned.split(' ');
        const firstWord = parts[0]?.toLowerCase().replace('.', '');

        // Set the known title variables
        const knownTitles = [
            'dhr', 'de heer', 'meneer',
            'mevr', 'mevrouw',
            'mr', 'mrs',
            'fam', 'familie'
        ];

        let title;
        let nameParts = [...parts];

        // Get the title and name parts
        if (knownTitles.includes(firstWord)) {
            title = parts[0];
            nameParts = parts.slice(1);
        }

        if (nameParts.length >= 2) {
            return {
                title,
                first_name: nameParts.slice(0, -1).join(' '),
                last_name: nameParts[nameParts.length - 1]
            };
        }

        return {
            title,
            first_name: nameParts[0]
        };
    }

    // Parse the person name values from the search value
    const parsedSearchValue = searchValue ? parsePersonName(searchValue) : null;

    // Plug in the fields and their properties:
    const fields: FieldType[] = [
        {
            name: 'title',
            label: 'person.general.salutation_label',
            type: 'text',
            placeholder: 'person.general.salutation_placeholder',
            ...(parsedSearchValue?.title ? { defaultValue: parsedSearchValue.title } : {}),
            group: 'field-row',
            width: '35%'
        },
        {
            name: 'first_name',
            label: 'person.general.first_name_label',
            type: 'text',
            placeholder: 'person.general.first_name_placeholder',
            ...(parsedSearchValue?.first_name ? { defaultValue: parsedSearchValue.first_name } : {}),
            group: 'field-row',
            width: '65%'
        },
        {
            name: 'last_name',
            label: 'person.general.last_name_label',
            type: 'text',
            placeholder: 'person.general.last_name_placeholder',
            ...(parsedSearchValue?.last_name ? { defaultValue: parsedSearchValue.last_name } : {}),
        },
        {
            name: 'phone_number',
            label: 'person.general.phone_number_label',
            type: 'text',
            placeholder: 'person.general.phone_number_placeholder',
        },
        {
            name: 'email',
            label: 'person.general.email_address_label',
            type: 'text',
            placeholder: 'person.general.email_address_placeholder',
        },
    ];

    return (
        <FormModal 
            viewKey={viewKey}
            apiObject={apiObject}
            fields={fields}
            linkedItem={linkedItem}
        />
    );
};

export default PersonForm;